module.exports = __webpack_public_path__ + "img/logo-footer.633ef4ea.png";